import 'vite/modulepreload-polyfill'

import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'

import SwupPreloadPlugin from '@swup/preload-plugin'
import Swup from 'swup'

import CartStore from '@/stores/cart-store'
import SiteStore from '@/stores/site-store'
import RecentlyViewedStore from '@/stores/recently-viewed'

import Header from '@/components/header'
import SearchForm from '@/components/search-form'
import Footer from '@/components/footer'
import Product from '@/components/product'
import HeroCarousel from '@/components/product-carousel'
import NewsletterForm from '@/components/newsletter-form'
import ProductForm from '@/components/product-form'
import QuickAddForm from '@/components/quick-add-form'
import Select from '@/components/select'
import RecommendedProducts from '@/components/related-products'
import Collection from '@/components/collection'
import IntroAnimation from '@/components/intro-animation'

class App {
	constructor() {
		this.setVh = this.setVh.bind(this)

		window.addEventListener('DOMContentLoaded', () => {
			this.init()
		})
	}

	init() {
		this.setVh()

		this.setupEventListeners()
		this.setupSwup()
		this.setupAlpine()
	}

	setVh() {
		const vh = window.innerHeight * 0.01
		document.documentElement.style.setProperty('--vh', `${vh}px`)
	}

	setupEventListeners() {
		window.addEventListener('resize', this.setVh)
	}

	setupSwup() {
		this.swup = new Swup({
			anchors: true,
			containers: ['#page'],
			plugins: [new SwupPreloadPlugin()],
			considerQueryString: true,
		})

		this.setupSwupHooks()
	}

	setupSwupHooks() {
		this.swup?.hooks.on('content:replace', () => {
			const scroll = window.scrollY
			const el = document.querySelector('.is-removing-container')
			if (el) {
				el.style.transform = `translateY(-${scroll}px)`
			}
		})
	}

	setupAlpine() {
		this.alpine = Alpine

		// Plugins
		Alpine.plugin(intersect)
		Alpine.plugin(collapse)
		Alpine.plugin(focus)

		// Stores
		Alpine.store('cart', CartStore)
		Alpine.store('site', SiteStore)
		Alpine.store('recentlyViewed', RecentlyViewedStore)

		// Components
		Alpine.data('Header', Header)
		Alpine.data('SearchForm', SearchForm)
		// Alpine.data('PredictiveSearch', PredictiveSearch)
		// Alpine.data('MainSearch', MainSearch)
		Alpine.data('Footer', Footer)
		Alpine.data('Product', Product)
		Alpine.data('HeroCarousel', HeroCarousel)
		Alpine.data('ProductForm', ProductForm)
		Alpine.data('QuickAddForm', QuickAddForm)
		Alpine.data('Select', Select)
		Alpine.data('NewsletterForm', NewsletterForm)
		Alpine.data('RecommendedProducts', RecommendedProducts)
		Alpine.data('Collection', Collection)
		Alpine.data('IntroAnimation', IntroAnimation)
		Alpine.start()
	}
}

window.app = new App()
